import { v4 as uuidv4 } from 'uuid';
import { isEmpty, uniq } from 'lodash';
import { propsReadApi } from '../../../api/curator';
import { fetchAllPages } from '../../../helpers/apiHelper';
import { dispatcher } from '../../../helpers/projectHelper';
import {
  getTextureLinking,
  loadSceneLabels,
} from '../../../redux/slicers/configurator/configurator.actions';
import {
  configuratorSceneProductsActions,
  selectSceneProducts,
  selectSceneProductsLoaded,
} from '../../../redux/slicers/configurator/configuratorSceneProducts.slicer';
import { getAppState } from '../../../redux/store';
import { configuratorModule, LabelsController } from './unityMethods';
import { loadUnityProps } from '../../../pages/admin/curator/projectParser/loadUnityProps';
import {
  configuratorActions,
  selectAllSceneInitPropsLoaded,
  selectBaseMaterialData,
  selectCalledOnce,
  selectConfiguratorData,
  selectIs360Configurator,
  selectSceneById,
  selectUnityLoaded,
} from '../../../redux/slicers/configurator/configurator.slicer';
import { configuratorUnityObjectActions } from '../../../redux/slicers/configurator/configuratorUnityObject.slicer';
import { waitForEventOnce } from '../../../helpers/unityPubSub';
import {
  // CONFIGURATOR_APP_EVENT,
  CONFIGURATOR_UNITY_EVENT,
} from './unityCallbacks';
import { errorToastV2 } from '../../../helpers/toastHelper';
import { getJson } from '../../../helpers/axiosHelper';
import { selectSceneLabels } from '../../../redux/slicers/configurator/configuratorSceneLabels.slicer';
import { getLabelOptions, getSceneViewsApi } from '../../../api/configuratorApi';
import { loadUnityMaterialDetails } from '../../../pages/admin/curator/projectParser/loadUnityMaterialDetails';
import {
  apiGetMaterialsV2,
  apiGetRenderBasedOnProjectRenderId,
  apiGetTextureList,
} from '../../../helpers/api';
import { setUnityObjectImagesProcessing } from '../../../redux/slicers/admin/curatorLoaderSlicer';
import { undoRedo } from '../../admin/curator/UndoRedo/UndoRedo';
import { DEFAULT_FOV } from '../../../constants/productConfiguratorConstants';
import { isV2 } from '../utils';
import { updateDbTexture } from '../../../helpers/idb';

export const defaultCamera = {
  distanceToSet: 5.8743,
  fov: DEFAULT_FOV,
  xTransRot: 90,
  yTransRot: 180,
  zTransRot: 0,
  wTransRot: 0,
  centerObjectxPos: -2.0455,
  centerObjectyPos: 1.0611,
  centerObjectzPos: -0.6033,
  isCameraCorrection: false,
  lensShiftY: 0,
  cameraHeight: 0,
  cameraRotX: 0,
  cameraRotZ: 0,
  focalLength: 34,
  isdepthOfField: false,
  selectedObjectName: '',
  blurIntensity: 0,
  xPos: 3.5147,
  yPos: 1.0611,
  zPos: 5.271,
  cameraName: 'BR54 Camera_1',
  resoX: 1920,
  resoY: 1080,
  sensor_width: 20,
  sensor_height: 11.2,
};

export const retailAutomationDefaultCamera = {
  distanceToSet: 4.115504,
  fov: 20.0,
  xTransRot: 0.0,
  yTransRot: 180.0,
  zTransRot: 0.0,
  centerObjectxPos: 0.01873487,
  centerObjectyPos: 0.980176747,
  centerObjectzPos: -0.00574419834,
  isCameraCorrection: false,
  lensShiftY: 0.0,
  cameraHeight: 0.980176747,
  cameraRotX: 180.0,
  cameraRotZ: 0.0,
  focalLength: 31.7591782,
  isdepthOfField: false,
  selectedObjectName: null,
  focusXPos: '',
  focusYPos: '',
  focusZPos: '',
  blurIntensity: 5.0,
  xPos: 0.01873522,
  yPos: 0.980176747,
  zPos: 3.99425578,
  cameraName: null,
  resoX: 0.0,
  resoY: 0.0,
  isPredefinedCamera: false,
  is_lock: true,
  safeFrameWidth: 0.0,
  safeFrameHeight: 0.0,
  canvas_width: 0.0,
  canvas_height: 0.0,
  sensor_width: 20.0,
  sensor_height: 11.2,
  gate_fit: 'overscan',
  fov_axis: 'vertical',
  horizontalFov: 0.0,
  startAngle: 0,
  lastAngle: 360,
};

export const resetData = () => {
  dispatcher(configuratorActions.setAllDataProcessed(true));
  dispatcher(configuratorActions.setUnitySceneLoaded(true));
  dispatcher(configuratorActions.setAllOptionsLoaded(true));
};

export const initializeConfigurator = () => {
  const configuratorData = selectConfiguratorData(getAppState());
  const is360Configurator = selectIs360Configurator(getAppState());
  const isNewConfigurator = Boolean(configuratorData?.is_new_configurator);
  const config = {
    roomCameraInfo: defaultCamera,
    transformData: {},
    props: [],
    userCameraInfo: [],
    materialVersion: 'V3',
    // baseMaterialData: {},
    // selectedOption: {},
    isNewConfigurator,
  };
  if (!isV2()) {
    config.isThreeSixtyConfigurator = is360Configurator;
  }
  configuratorModule.InitializeConfigurator(config);
  configuratorModule.projectModule.SendRoomLoadedCompletelyInfo();
  // dispatcher(configuratorActions.setSelectedOptionAll({}));
  dispatcher(configuratorActions.setAllDataProcessed(true));
};

export const initUnity = async ({ sceneId }) => {
  if (!sceneId) {
    resetData();
    return;
  }
  // TODO: refactor this logic -> or wait when unity implements it
  const callOnlyOnce = selectCalledOnce(getAppState());
  const is360Configurator = selectIs360Configurator(getAppState());
  const configuratorData = selectConfiguratorData(getAppState());
  const isNewConfigurator = Boolean(configuratorData?.is_new_configurator);
  const baseMaterialData = selectBaseMaterialData(getAppState());
  dispatcher(configuratorUnityObjectActions.setPropTree([]));
  dispatcher(configuratorActions.setAllSceneInitPropsLoaded(false));
  dispatcher(configuratorActions.setUnitySceneLoaded(false));
  // need to check if there is an issue if we don't reset the initial properties of the object
  // dispatcher(configuratorActions.updateInitialObjectProperties([]));
  dispatcher(configuratorActions.setMaterialToUpdate([]));
  setUnityObjectImagesProcessing(false);
  dispatcher(configuratorActions.setInitialMaterialApplied(false));
  dispatcher(configuratorActions.setDefaultTextures(null));
  dispatcher(configuratorActions.setAllDataProcessed(false));
  dispatcher(configuratorActions.setAddRenderersCount(0));
  dispatcher(configuratorActions.setBackupDefaultTextures([]));
  dispatcher(configuratorActions.resetUnlinkedObjectsAfterDelete([]));
  dispatcher(
    configuratorActions.setObjectsAfterDeleteOperationCompleted({
      rawData: [],
      parentData: [],
    })
  );
  dispatcher(configuratorUnityObjectActions.setSelectedObjects([]));
  dispatcher(configuratorActions.setAllOptionsLoaded(false));
  dispatcher(configuratorActions.setSkipSaveSceneJson(false));
  undoRedo.resetHistory();

  if (callOnlyOnce) {
    configuratorModule.ResetConfiguratorReceiver();
    await waitForEventOnce(CONFIGURATOR_UNITY_EVENT.OnConfiguratorSceneLoaded);
    // PubSub.publish(CONFIGURATOR_APP_EVENT.RESET_CONFIGURATOR_SCENE);
  }

  if (!sceneId) {
    errorToastV2('Unable to load scene json. LF_C_992S');
    resetData();
    return;
  }

  const sceneJson = await getSceneJson(sceneId);

  initSceneLables(sceneId, sceneJson);

  const unityProps = await getInitialUnityProps(sceneJson);
  if (isEmpty(unityProps)) {
    dispatcher(
      configuratorSceneProductsActions.fetchSceneProductsSuccess({ sceneId, products: [] })
    );
  }

  if (!baseMaterialData) {
    const materials = await apiGetMaterialsV2({ query: 'search=Matte+Finish', page: 1 });
    if (materials?.results?.length) {
      dispatcher(configuratorActions.setBaseMaterialData(materials?.results[0]));
    }
  }

  if (!sceneJson) {
    initializeConfigurator();
    return;
  }

  const config = {
    roomCameraInfo: sceneJson.roomCameraInfo,
    roomLightData: sceneJson?.roomLightData || [],
    transformData: sceneJson.transformChangedObjectData || {},
    deletedObjectsData: sceneJson?.deletedObjectsData || sceneJson?.deletedObjectData || [],
    propsHierarchyData: sceneJson.propsHierarchyData,
    materialDetails: sceneJson.materialDetails,
    materialVersion: sceneJson.materialVersion,
    duplicatePropDatas: sceneJson.duplicatePropDatas,
    // selectedOption: sceneJson?.selectedOption || {},
    // baseMaterialData: sceneJson?.baseMaterialData || {},
    userCameraInfo: [],
    labelOptionsDict: null,
    props: unityProps,
    groupPropsMapping: sceneJson?.groupPropsMapping || {},
    isNewConfigurator,
  };

  if (!isV2()) {
    config.isThreeSixtyConfigurator = is360Configurator;
  }

  configuratorModule.CreateConfiguratorReceiver(config);

  // dispatcher(configuratorActions.setSelectedOptionAll(sceneJson?.selectedOption || {}));

  await Promise.all([
    loadUnityProps({
      unityPropList: unityProps,
      initProp: configuratorModule.InstantiatePropReceiever,
      unityLoadedSelector: selectUnityLoaded,
      fetchProps: createPropsLoader(
        sceneId,
        sceneJson.groupPropsMapping,
        sceneJson.blenderAssetBundleDatas,
        selectSceneById(sceneId)(getAppState())
      ),
    }),
  ]);
};

// A catalog "prop group" product's own product_file is a JSON manifest carrying its packaged
// default materialDetails (same file addGroupProp/SceneAddProduct.js fetches when a group is first
// placed) - unlike sceneJson.materialDetails, which reflects every material a user has since
// applied in the configurator, this file is never touched by scene edits, so it's the single
// source of truth for a group child's default material.
const groupProductJsonCache = {};

const getGroupProductJson = async (sceneId, groupId) => {
  if (groupProductJsonCache[groupId]) return groupProductJsonCache[groupId];

  try {
    let groupRecord = (sceneRawPropsCache[sceneId] || []).find(
      (prop) => Number(prop?.id) === Number(groupId)
    );
    if (!groupRecord) {
      const result = await fetchAllPages((page) => propsReadApi([groupId], page));
      groupRecord = result?.results?.[0];
    }
    if (!groupRecord?.product_file) return null;

    const productJson = await getJson(groupRecord.product_file);
    groupProductJsonCache[groupId] = productJson;
    return productJson;
  } catch (e) {
    console.error(e);
    return null;
  }
};

// A group's product json bakes its objectNames at some baseline instance index (e.g.
// "1_2pillow3_1@7728"), but the live scene assigns each *placed* instance its own index (e.g.
// "5_2pillow3_5@7728" for one instance and "6_2pillow3_6@7728" for a second instance of that same
// group product placed elsewhere in the same scene) - so template names never literally match live
// ones. childrenObjects' actualchildName (e.g. "2pillow3") is the only part that stays stable across
// every instance and the template alike, so it's what ties a template material back to every live
// object that needs it.
const renameMaterialObjectName = (material, objectName) => {
  const renamed = { ...material, objectName };
  if ('objName' in material) renamed.objName = objectName;
  if ('OtherObjectName' in material) renamed.OtherObjectName = objectName;
  return renamed;
};

// collects the default materialDetails entries (from each group's own product json) belonging to
// any group prop's instantiated children - groupPropsMapping only lists each instance's top-level
// object names (e.g. "3@7728"), so those are cross-referenced against blenderAssetBundleDatas to
// get each instance's actual child object names (e.g. "3_2pillow3_3@7728"). sceneJson is only used
// to know which object names are actually live in this scene and how they map back to the group's
// own child names (via actualchildName) - the material values themselves always come from product json.
//
// groupPropsMapping's own key (groupId, fetched below via getGroupProductJson) is the catalog
// "prop group" product's own id - the one whose product_file is a JSON manifest (same as
// addGroupProp/SceneAddProduct.js fetches). Each blenderAssetBundleDatas entry inside a placed
// instance is a DIFFERENT id - one of that catalog group's individual child products (e.g. 7728,
// a pillow/duvet set) - whose own product_file is a compiled Unity asset bundle, not JSON. Those
// child ids are what tie a live instance back to the matching entry inside the group's own
// product json (both list that same child product's id in their own blenderAssetBundleDatas).
export const getGroupPropMaterialDetails = async (sceneId, sceneJson) => {
  const groupIds = Object.keys(sceneJson?.groupPropsMapping || {});
  if (!groupIds.length) return [];

  const groupInstanceObjectNames = new Set();
  Object.values(sceneJson.groupPropsMapping).forEach((group) => {
    Object.values(group?.groupData || {}).forEach((instance) => {
      (instance?.objectNames || []).forEach((name) => groupInstanceObjectNames.add(name));
    });
  });

  if (!groupInstanceObjectNames.size) return [];

  // live child-product instances actually placed in this scene, keyed by that child product's own
  // id (e.g. "7728") - a single group placement can bundle several distinct child products, so
  // this is built once across every group rather than per group.
  const instancesByChildProductId = {};
  (sceneJson?.blenderAssetBundleDatas || [])
    .filter((a) => groupInstanceObjectNames.has(a?.objectName))
    .forEach((a) => {
      const childProductId = String(a.id);
      instancesByChildProductId[childProductId] = instancesByChildProductId[childProductId] || [];
      const childByActualName = new Map(
        (a?.childrenObjects || []).map((c) => [c.actualchildName, c.childName])
      );
      instancesByChildProductId[childProductId].push({ topName: a.objectName, childByActualName });
    });

  if (!Object.keys(instancesByChildProductId).length) return [];

  const materialsPerGroup = await Promise.all(
    groupIds.map(async (groupId) => {
      const productJson = await getGroupProductJson(sceneId, groupId);
      if (!productJson) return [];

      return (productJson?.blenderAssetBundleDatas || []).flatMap((templateAsset) => {
        const instances = instancesByChildProductId[String(templateAsset?.id)];
        if (!instances?.length) return [];

        const templateChildActualNameByChildName = new Map(
          (templateAsset?.childrenObjects || []).map((c) => [c.childName, c.actualchildName])
        );

        return (productJson?.materialDetails || []).flatMap((material) => {
          // the child product's own top-level material (rare, but possible) - reapply to every
          // live instance of that child product's own top-level object name.
          if (material.objectName === templateAsset.objectName) {
            return instances.map((instance) => renameMaterialObjectName(material, instance.topName));
          }

          const actualChildName = templateChildActualNameByChildName.get(material.objectName);
          if (!actualChildName) return [];

          return instances
            .map((instance) => {
              const liveChildName = instance.childByActualName.get(actualChildName);
              return liveChildName ? renameMaterialObjectName(material, liveChildName) : null;
            })
            .filter(Boolean);
        });
      });
    })
  );

  return materialsPerGroup.flat();
};

// Sometimes a group prop's json contains an outdated diffusePath, causing props to load with
// stale materials. Clearing these forces Unity to always fetch the current path.
// https://app.clickup.com/t/3326989/DEV-35282
export const stripStaleMaterialPaths = (materialDetails = []) =>
  materialDetails.map((material) => ({
    ...material,
    diffusePath: '',
    loadedMaterialPath: '',
    normalPath: '',
    roughnessPath: '',
    displacementPath: '',
    metallicPath: '',
    transparencyPath: '',
    AOPath: '',
  }));

const getInitialUnityProps = async (sceneJson) => {
  const unityPropList = sceneJson?.blenderAssetBundleDatas?.map((a) => {
    const transformProp = sceneJson?.transformChangedObjectData?.[a?.objectName];
    if (transformProp) {
      return {
        type: 'ConfiguratorProjectProp',
        id: a.id,
        objectName: a.objectName,
        indexName: a.objectIndex,
        xPosition: transformProp.xPosition,
        yPosition: transformProp.yPosition,
        zPosition: transformProp.zPosition,
        xRotation: transformProp.xRotation,
        yRotation: transformProp.yRotation,
        zRotation: transformProp.zRotation,
        wRotation: transformProp.wRotation,
        xScale: transformProp.xScale,
        yScale: transformProp.yScale,
        zScale: transformProp.zScale,
        propLoaderId: uuidv4(),
        isMattressBuilderGroupProp: false,
        ...(a.is_metadata && a.product_meta_info
          ? { preDefinedMetadata: a.product_meta_info }
          : {}),
      };
    }
    return null;
  });
  const propListWithData = unityPropList?.filter((val) => Boolean(val));
  return propListWithData;
};

// full prop-details list (group prop children included) keyed by sceneId, used to re-instantiate
// props in Unity when revisiting an already-loaded scene. Kept out of Redux because the sidebar's
// `products` cache there is filtered down to one card per group and must not be reused as the
// full detail list Unity needs - group children never appear in it, by design (see below).
const sceneRawPropsCache = {};

const createPropsLoader =
  (sceneId, groupPropsMapping = {}, scenePropList = [], scene = null) =>
  async (propIds) => {
    if (isEmpty(propIds)) {
      dispatcher(
        configuratorSceneProductsActions.fetchSceneProductsSuccess({ sceneId, products: [] })
      );
      return {
        results: [],
      };
    }

    // scene.sceneproduct_data is the scene's own explicit record of which catalog products (group
    // or standalone) the user actually added, kept correct by SceneAddProduct.js's handlePropClick
    // on every add/remove - unlike groupPropsMapping/blenderAssetBundleDatas (both read off Unity's
    // live/persisted scene json), it is never touched by loading or unloading a lightroom. A
    // lightroom's own group can still end up captured into groupPropsMapping if some unrelated
    // Unity event saves the scene while that lightroom happens to be loaded (useSaveSceneCallbacks.js
    // has several triggers unrelated to lightrooms); filtering the sidebar itself against
    // sceneproduct_data means that kind of leftover can never surface as a card here regardless of
    // how it got into the json.
    const sceneProductIds = new Set(
      (scene?.sceneproduct_data || [])
        .map((val) => Number(val?.product))
        .filter((id) => !Number.isNaN(id))
    );
    const isOwnedByScene = (id) => !sceneProductIds.size || sceneProductIds.has(Number(id));

    // a group prop's children need their own full details fetched same as any other prop (Unity
    // still needs each one's real asset data to instantiate it), but the SceneProducts sidebar
    // should show one card per group instead of one per child - build that grouping separately
    // from the details, so the fetch below still covers every individual id.
    // groupData is keyed by the group container's own objectName (one entry per placed instance,
    // e.g. "1@21710_groupProp"), each listing its children's real Unity objectNames (e.g.
    // "1@10870") - NOT keyed by child prop id - so the child id has to be parsed out of the
    // objectName ("{index}@{id}") instead of read off the key.
    // Groups the scene doesn't actually own (per sceneproduct_data) are skipped entirely here -
    // their children never enter groupedObjectNames, so a foreign group can't mark some other,
    // genuinely scene-owned id as "grouped" just by coincidentally sharing a live object name.
    const groupIds = Object.keys(groupPropsMapping || {}).filter(isOwnedByScene);
    const groupChildrenById = {};
    const groupedObjectNames = new Set();
    groupIds.forEach((groupId) => {
      const groupData = groupPropsMapping[groupId]?.groupData || {};
      const groupChildren = Object.values(groupData).flatMap((instance) =>
        (instance?.objectNames || []).map((objectName) => {
          const id = parseInt(objectName?.split('@')?.[1]);
          groupedObjectNames.add(objectName);
          return { id, objectName };
        })
      );
      groupChildrenById[groupId] = groupChildren;
    });

    // A product id only hides from the sidebar (rolled into its group's card) when every live
    // instance of that id is actually a group child. If the same id is *also* placed standalone
    // (its own live objectName isn't among any group's recorded objectNames), that standalone
    // instance keeps its own card - same "standalone wins" precedent as buildSafeGroupPropsMapping
    // in LightingListV2Helper.js, applied here so a shared id doesn't vanish from "Add products".
    const idsWithStandaloneInstance = new Set(
      (scenePropList || [])
        .filter((prop) => prop?.objectName && !groupedObjectNames.has(prop.objectName))
        .map((prop) => Number(prop?.id))
    );
    const groupedChildIds = new Set(
      Array.from(groupedObjectNames)
        .map((objectName) => parseInt(objectName?.split('@')?.[1]))
        .filter((id) => !Number.isNaN(id) && !idsWithStandaloneInstance.has(id))
    );

    // every individual id (children included) plus each group's own id, through the same generic
    // endpoint used for any other prop - matches how Curator's own group-add flow
    // (loadGroupPropMaterials) fetches child details, no special-casing needed.
    const propIdList = uniq([...propIds, ...groupIds.map((id) => parseInt(id))]);

    // Combine whatever we already know about these ids: Redux's per-scene product cache (kept
    // correct for standalone props by addProductsToScene/removeProductsFromScene as the user
    // adds/removes them without switching scenes) plus our own raw cache of full detail (Redux's
    // copy never has group children in it - see comment above). Only ids present in NEITHER are
    // actually missing and worth a network round trip; this keeps a scene revisit cheap while
    // staying correct regardless of how the caches got there.
    const knownById = new Map();
    (sceneRawPropsCache[sceneId] || []).forEach((prop) => knownById.set(Number(prop.id), prop));
    if (selectSceneProductsLoaded(sceneId)(getAppState())) {
      selectSceneProducts(sceneId)(getAppState()).forEach((prop) =>
        knownById.set(Number(prop.id), prop)
      );
    }
    const missingIdList = propIdList.filter((id) => !knownById.has(Number(id)));

    if (missingIdList.length) {
      dispatcher(configuratorSceneProductsActions.fetchSceneProductsStart({ sceneId }));

      const propsObj = {};

      await Promise.all(
        uniq(missingIdList).map(async (productId) => {
          const result = await fetchAllPages((page) => propsReadApi([productId], page));
          // TODO: handle prop loading failed
          propsObj[productId] = result?.results || [];
        })
      );

      missingIdList.forEach((id) => {
        (propsObj?.[id] || []).forEach((prop) => knownById.set(Number(prop.id), prop));
      });
    }

    const props = propIdList.map((id) => knownById.get(Number(id))).filter(Boolean);

    if (!props?.length) {
      errorToastV2('Product is not present');
    }

    // the sidebar shows one card per group instead of one per child - exclude individual grouped
    // children from the display list and reattach groupChildren onto each group's own card (same
    // shape addGroupProp produces), while `props` (returned below) still has every child's full
    // details intact for Unity to instantiate. Also drop anything sceneproduct_data doesn't
    // actually list - a leftover standalone id from the same kind of contamination groupIds above
    // guards against should not get its own card either.
    const displayProducts = props
      .filter((prop) => isOwnedByScene(prop.id))
      .filter((prop) => !groupedChildIds.has(parseInt(prop.id)))
      .map((prop) => {
        const groupChildren = groupChildrenById[prop.id];
        return groupChildren ? { ...prop, groupChildren } : prop;
      });

    sceneRawPropsCache[sceneId] = props;

    dispatcher(
      configuratorSceneProductsActions.fetchSceneProductsSuccess({
        sceneId,
        products: displayProducts,
      })
    );

    return {
      results: props,
    };
  };

export const getSceneJson = async (sceneId, isUpdate = true) => {
  const scene = selectSceneById(sceneId)(getAppState());
  let sceneJson = scene?.json_file_content;

  if (!sceneJson) {
    // it's not loaded yet or it's missing

    if (scene?.json_file) {
      try {
        sceneJson = await getJson(scene.json_file);
        if (isUpdate) {
          dispatcher(
            configuratorActions.updateScene({ id: scene.id, json_file_content: sceneJson })
          );
        }
      } catch (e) {
        errorToastV2('Unable to load scene configuration. CODE: LF_C_78324');
        return false;
      }
    }
  }

  // current scene doesn't have json file yet, return nothing

  return sceneJson;
};

export const initSceneLables = async (sceneId, sceneJson) => {
  const loadDataPromises = [];
  const initPropsLoaded = selectAllSceneInitPropsLoaded(getAppState());

  if (!sceneJson) {
    sceneJson = await getSceneJson(sceneId);
  }

  loadDataPromises.push(loadSceneLabels({ sceneId, onlyOnce: false }));

  if (!initPropsLoaded) {
    loadDataPromises.push(waitForEventOnce(CONFIGURATOR_UNITY_EVENT.OnAllConfiguratorPropsLoaded));
  }

  // const cancelPromise = waitForEventOnce(CONFIGURATOR_APP_EVENT.RESET_CONFIGURATOR_SCENE)

  const result = await Promise.race([
    Promise.all(loadDataPromises),
    // cancelPromise
  ]);

  if (!Array.isArray(result)) {
    // scene was reset we don't need to load labels
    return;
  }

  // all scene props was just loaded and we fetched labels data
  // now we can add labels to unity

  const labels = selectSceneLabels(sceneId)(getAppState());
  let allObjects = [];

  dispatcher(getSceneViewsApi({ sceneId, showLoading: false, onlyOnce: false }));

  if (isV2()) {
    getTextureLinking({ sceneId });
  }

  const groupPropMaterials = stripStaleMaterialPaths(
    await getGroupPropMaterialDetails(sceneId, sceneJson)
  );
  
  if (groupPropMaterials?.length) {
    const roomLoadedCompletely = waitForEventOnce(CONFIGURATOR_UNITY_EVENT.OnRoomLoadedCompletely);
    dispatcher(configuratorActions.setSkipSaveSceneJson(true));
    await loadUnityMaterialDetails({
      materialDetails: groupPropMaterials,
      unityContext: configuratorModule,
      unityLoadedSelector: selectUnityLoaded,
    });
    await roomLoadedCompletely;
    dispatcher(configuratorActions.setSkipSaveSceneJson(false));
  }

  labels.forEach((label) => {
    if (!label.data?.linkedObjects) return;
    const objectNames = label.data.linkedObjects.map((o) => o.objectName);
    allObjects = allObjects.concat(objectNames);
    if (objectNames?.length) {
      LabelsController.AddRenderersToGroup(label.id, objectNames);
    }
  });

  await Promise.all(
    labels.map(async (label) => {
      await dispatcher(getLabelOptions({ labelId: label.id, onlyOnce: false }));
    })
  );

  dispatcher(configuratorActions.setAllOptionsLoaded(true));

  if (!allObjects?.length) {
    configuratorModule.projectModule.SendRoomLoadedCompletelyInfo();
    dispatcher(configuratorActions.setAllDataProcessed(true));
  }
};

export const removeLoader = () => {
  dispatcher(configuratorActions.setShowFullScreenLoader(false));
};

export const getProjectJsonData = async (toOperate, loadedFrom) => {
  let projectJson;
  let renderId;
  if (loadedFrom === 'projects' || loadedFrom === 'rooms') {
    const jsonFile = toOperate.json_file;
    if (!jsonFile) {
      removeLoader();
      errorToastV2('Project configuration is missing. CODE: LF_93lskd27');
      return;
    }
    try {
      projectJson = await getJson(jsonFile);
    } catch (e) {
      removeLoader();
      errorToastV2('Project configuration is missing. CODE: LF_78324');
      return;
    }
  }
  if (loadedFrom === 'images') {
    // load render
    const getRenderResult = await apiGetRenderBasedOnProjectRenderId(toOperate.object_id);
    renderId = toOperate.id;
    if (!getRenderResult?.data?.result?.id) {
      removeLoader();
      errorToastV2('Project configuration is missing. CODE: LF_78324');
      return;
    }

    const renderData = getRenderResult.data.result;

    // if (renderData.render_name) {
    //   dispatch(setPageTitle(`Render: "${renderData.render_name}"`));
    // }

    if (!renderData.json_data) {
      // errorToastV2('Unable to load room, render json data is missing, LF_783koo24')
      return;
    }

    projectJson = renderData.json_data;

    const automationActionData = renderData.automation_action || {};

    if (Object.keys(automationActionData).length > 0) {
      projectJson.automationObjectsData = await Promise.all(
        automationActionData.aa_objects.map(async (a) => {
          if (!a.color_code && !a.texture?.id) return;

          let url;
          if (a.texture) {
            const query = `id=${a.texture.id}`;
            const textures = await apiGetTextureList({ query });
            const texture = textures.results?.[0];
            const textureDbData = await updateDbTexture(texture);
            url = textureDbData?.file;
          }

          const urlHttp = a.texture?.texture_file;

          let ext;
          if (urlHttp) {
            ext = urlHttp.split(/[#?]/)[0].split('.').pop().trim();
          }

          return {
            objectName: a.object_name,
            colorCode: a.color_code,
            textureId: a.texture?.id,
            textureName: a.texture?.name,
            textureUrl: url,
            textureVersion: a.texture?.version,
            textureFormat: ext,
            skuId: a.texture?.sku_id,
            textureWidth: a.texture?.width,
            textureHeight: a.texture?.height,
          };
        })
      );

      projectJson.automationObjectsData = projectJson.automationObjectsData.filter(
        (a) => a !== undefined
      );
    }
  }
  return { projectJson, renderId };
};
